import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box, Row } from '@/components/lib/components';
import { designSystem } from '@/styles/styles';

const SKELETON_COLOR = designSystem.colors.neutral300;
const ROW_COUNT = 8;
const rows = Array.from({ length: ROW_COUNT }, (_, index) => index);

export const AllLeaguesSkeleton = () => (
    <Box paddingHorizontal={'s16'}>
        <LoadingSkeleton
            skeletonColor={SKELETON_COLOR}
            width={96}
            height={16}
            borderRadius={'r4'}
            marginTop={'s12'}
            marginBottom={'s8'}
        />
        {rows.map(index => (
            <Row key={index} alignItems={'center'} gap={'s16'} py={'s16'}>
                <LoadingSkeleton skeletonColor={SKELETON_COLOR} width={24} height={24} borderRadius={'r12'} />
                <LoadingSkeleton skeletonColor={SKELETON_COLOR} width={160} height={16} borderRadius={'r4'} />
            </Row>
        ))}
    </Box>
);
